import { Modified } from '../_models/base-inquiry-dates-form';
import { ShiftTimeResponse, ShiftType } from '../../../../api';

export enum BaseCustomerInquiryFilters {
  department = 'customerDepartments',
  location = 'customerLocations',
  mainQualification = 'mainQualifications',
  status = 'status',
  createdBy = 'createdBy',
  search = 'search',
}

export enum BaseInquiryFilters {
  customerDepartments = 'customerDepartments',
  customerLocations = 'customerLocations',
  mainQualifications = 'mainQualifications',
  status = 'status',
  pspBranches = 'pspBranches',
  customers = 'customers',
  createdBy = 'createdBy',
  psp = 'psp',
}

export enum BaseInquiryOffersFilters {
  status = 'status',
  rating = 'rating',
  experience = 'experience',
  pspBranches = 'pspBranches',
  mainQualifications = 'mainQualifications',
  workCouncilStatus = 'workCouncilStatus',
  search = 'search',
}

export enum BaseOfferAndCandidatesFilters {
  qualifications = 'qualifications',
  status = 'status',
  experience = 'experience',
  search = 'search',
}

export const BaseInquiryStatus = {
  unpublished: 1,
  published: 2,
  closed: 3,
  declined: 4,
} as const;
export type BaseInquiryStatusType = typeof BaseInquiryStatus[keyof typeof BaseInquiryStatus];

export const BaseInquiryStatusValue = {
  1: 'unpublished',
  2: 'published',
  3: 'closed',
} as const;
export type BaseInquiryStatusValueType = typeof BaseInquiryStatusValue[keyof typeof BaseInquiryStatusValue];

export enum BaseOfferStatus {
  open = 0,
  declined = 2,
  confirmed = 3,
  statusRevoked = 4,
  needsConfirmation = 5,
  needsUpdate = 6,
  preselected = 100,
}

export const BaseShiftsArray: BaseInquiryShiftsType[] = ['fd', 'zd', 'sd', 'nd'];
export const BaseShiftsWithFlexArray: BaseInquiryShiftsWithFlexType[] = ['flex', 'fd', 'zd', 'sd', 'nd'];

export const BaseInquiryShifts = {
  fd: 'fd',
  zd: 'zd',
  sd: 'sd',
  nd: 'nd',
} as const;

export type BaseInquiryShiftsType = typeof BaseInquiryShifts[keyof typeof BaseInquiryShifts];

export const BaseInquiryShiftsWithFlex = {
  flex: 'flex',
  ...BaseInquiryShifts,
} as const;

export type BaseInquiryShiftsWithFlexType = typeof BaseInquiryShiftsWithFlex[keyof typeof BaseInquiryShiftsWithFlex];

export enum BaseShiftTimeIndexes {
  fd = 0,
  zd = 1,
  sd = 2,
  nd = 3,
}

export enum BaseShiftTimeLabelByValue {
  flex = 'flexShift',
  fd = 'shiftFd',
  zd = 'shiftZd',
  sd = 'shiftSd',
  nd = 'shiftNd',
}

export enum BaseWeekDays {
  MO = 'mo',
  TU = 'tu',
  WE = 'we',
  TH = 'th',
  FR = 'fr',
  SA = 'sa',
  SU = 'su',
}

export enum BaseWeekDaysAlt {
  mo = 'mon',
  tu = 'tue',
  we = 'wed',
  th = 'thu',
  fr = 'fri',
  sa = 'sat',
  su = 'sun',
}

export enum BaseInquiryShiftsBooked {
  fd = 'shiftFdBooked',
  zd = 'shiftZdBooked',
  sd = 'shiftSdBooked',
  nd = 'shiftNdBooked',
}

export enum BaseInquiryShiftsUpperCase {
  fd = 'shiftFd',
  zd = 'shiftZd',
  sd = 'shiftSd',
  nd = 'shiftNd',
}

export type ShiftTimeAndFlexResponse = Modified<
  ShiftTimeResponse,
  {
    type: ShiftType | 'flex';
  }
>;

export const BaseShiftIcons = {
  fd: 'fa-sunrise',
  zd: 'fa-sun-bright',
  sd: 'fa-clock',
  nd: 'fa-moon-stars',
} as const;
export type BaseShiftIconsType = typeof BaseShiftIcons[keyof typeof BaseShiftIcons];

export const BaseShiftIconsWithFlex = {
  ...BaseShiftIcons,
  flex: 'fa-user-clock',
} as const;
export type BaseShiftIconsWithFlexType = typeof BaseShiftIconsWithFlex[keyof typeof BaseShiftIconsWithFlex];

export enum BaseShiftPersonsEnum {
  fd = 'fdPersons',
  zd = 'zdPersons',
  sd = 'sdPersons',
  nd = 'ndPersons',
}
